import React, { useState } from 'react';
import CreatableSelect from '@shared/components/inputs/selects/CreatableSelect';
import { ClickAwayListener } from '@shared/components/click-away-listener/click-away-listener';
import { TooltipEnabler } from '@domain/dashboard/budget-manager/modal/selector/budget-manager-selector.utils';
import { TaggedCampaignWrapper } from './tag-campaign-selector.styles';
import { TAG_CAMPAIGN_TEXTS, SEGMENTS_MODAL_TEST_ID, SEGMENTS_ARIAL_LABEL } from './tag-campaign-selector.constants';

interface TagCampaignSelectorProps {
    style: any;
    value?: string;
    tags?: Array<{label: string, value: string}>;
    loadingTag?: boolean;
    onChange: (event, subitem) => void;
    onCreateOption: (event, subitem) => void;
}

export const TagCampaignSelector = ({
    style, value, tags, loadingTag, onChange, onCreateOption,
}: TagCampaignSelectorProps) => {
    const [isHovering, setHovering] = useState(false);
    const selectedOption = tags.find(tag => tag.value === value)
        || { label: TAG_CAMPAIGN_TEXTS.tagsPlaceHolder, value: '-' };
    const options = isHovering ? tags : [selectedOption];

    return (
        TooltipEnabler(
            (
                <ClickAwayListener onClickAway={() => setHovering(false)}>
                    <TaggedCampaignWrapper
                        style={style}
                        data-testid={SEGMENTS_MODAL_TEST_ID.TAG_SELECT}
                        onClick={() => setHovering(true)}
                    >
                        <CreatableSelect
                            aria-label={SEGMENTS_ARIAL_LABEL.TAG_INPUT_SELECT_ARIAL_LABEL}
                            isLoading={loadingTag}
                            isMulti={false}
                            isClearable
                            options={options}
                            placeholder={TAG_CAMPAIGN_TEXTS.tagsPlaceHolder}
                            value={value}
                            defaultValue={value}
                            onChange={onChange}
                            onCreateOption={onCreateOption}
                            data-testid={SEGMENTS_MODAL_TEST_ID.TAG_CAMPAIGN_SELECTOR_TESTID}
                        />
                    </TaggedCampaignWrapper>
                </ClickAwayListener>), selectedOption.label,
        )
    );
};
